// Import global polyfills
import 'core-js/stable';

import * as HitchhikerJS from './js/HitchhikerJS';
window.HitchhikerJS = HitchhikerJS;

// Import all SCSS
import Scss from './scss/answers/_default.scss';
